import { logEvent } from './logGaEvent'

export const logNoBrandedFareSecondSliceEvent = ({ tripType, airlineName, isFused }) => {
  const attributes = {
    type: 'bf-shelf',
    product_name: 'air',
    page_name: 'listings',
    trip_type: tripType,
    airline_name: airlineName,
    is_fused: isFused,
  }
  logEvent('no_branded_fare_second_slice', attributes)
}
